import { Box, Grid, Typography, Link } from "@mui/material";
import CopyrightIcon from '@mui/icons-material/Copyright';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';

import FooterLinksComponent from "./footerLinksComponent";

const Footer = () => {
    const styles = {
        mainContainer: {
            backgroundColor:  '#1E4276',
            padding: '15px',
            height: '210px'
        },
        footerRightsContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            color: 'white',
            marginTop: '10px'
        },
        socialMediaIncon: {
            marginRight: '25px',
            cursor: 'pointer'
        },
        icon: {
            fontSize: '14px',
            marginBottom: '-2.5px'
        },
        socialMediaLink: {
            color: 'white',
            fontSize: '20px',
            "&:hover": {
                color: '#58758C'
            }
        },
        rightsText: {
            fontSize: '12px'
        }
        // socialMediaLink:hover: {
        //     fontSize: '24px',
        //     color: 'blue'
        // }
    }

    
    return (
        <Box sx={styles.mainContainer}>
            <Grid container>
               <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <FooterLinksComponent />
               </Grid>
            </Grid>
            <Grid container sx={styles.bottomContainer} spacing={3}>
                <Grid item xs={0} sm={1} md={1} lg={1} xl={1}></Grid>
                <Grid item container xs={12} sm={10} md={10} lg={10} xl={10} sx={styles.footerRightsContainer}>
                   <Typography sx={styles.rightsText}><CopyrightIcon style={styles.icon} /> 2025 ConectYu Hive Pvt Ltd. All rights reserved.</Typography>
                   <Grid item>
                        <Link href="https://www.instagram.com/conectyu" sx={styles.socialMediaLink}>
                            <InstagramIcon sx={styles.socialMediaIncon} />
                        </Link>
                        <Link href="https://twitter.com/ConectYu" sx={styles.socialMediaLink}>
                            <XIcon sx={styles.socialMediaIncon} />
                        </Link>
                   </Grid>
                </Grid>
                <Grid item  xs={0} sm={1} md={1} lg={1} xl={1}></Grid>
            </Grid>
        </Box>
    )
};

export default Footer;